const constants = {
    CONTENT_TYPES: {
        VIDEO: 'video',
        CLICK: 'click',
        ONE_THIRD_BANNER: 'one-third-banner',
        EXTENSION_UNIVERSAL: 'extension-universal'
    },

    COMPONENT_TYPES: {
        VIDEO: 'video',
        ONE_THIRD: 'one-third',
        FULL_SCREEN: 'full-screen'
    },

    TEMPLATE_VALUES: {
        FULL_SCREEN_TEMPLATE: 4
    },

    DIRECTION_MAP: {
        0: 'top',
        1: 'right',
        2: 'bottom',
        3: 'left'
    },

    EVENTS: {
        ALL_LAYERS_REFRESHED: 'App\\Events\\Streamers\\AllLayersRefreshed',
        LAYER_REFRESHED: 'App\\Events\\Streamers\\LayerRefreshed',
        TASK_LAUNCH: 'App\\Events\\Tasks\\TaskExecuted',
        TASK_TEST_MODE: 'App\\Events\\TestModeTurned',
        BK_CLICKED: 'App\\Events\\Tasks\\BurgerKingClicked'
    },

    DOMAINS: {
        MAIN: 'apiq.live',
        SECOND: 'apiqlive.ru'
    },

    PUSHER: {
        APP_KEY: process.env.VUE_APP_PUSHER_APP_KEY || '000000000',
        PATH: process.env.VUE_APP_PUSHER_PATH || '',
        HOST: process.env.VUE_APP_PUSHER_HOST || 'localhost',
        PORT: process.env.VUE_APP_PUSHER_PORT || 3000,
    },

    BACKEND_HOST: process.env.VUE_APP_BACKEND_HOST || 'localhost',

    KICK_PLATFORM_DELAY_MS: 7000,
}

constants.VIDEO_CONTENT_TYPES = [constants.CONTENT_TYPES.VIDEO, constants.CONTENT_TYPES.CLICK]

export default constants